import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../../../../page-components/common/DataElementContext';
import evBus from '../../../../utils/evbus';

type MyTicketsTogglerProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
  };
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const MyTicketsToggler = (componentProps: MyTicketsTogglerProps) => {
  const tmpProps = { ...defaultProps, ...componentProps };
  delete tmpProps.children;
  const props = JSON.parse(JSON.stringify(tmpProps));
  const { children } = componentProps;

  const [state, setState] = React.useState({
    open: false,
  });
  const eventBusType = props.properties?.eventBusType;

  const onToggle = () => {
    setState((prevState) => {
      return {
        ...prevState,
        open: !prevState.open,
      };
    });
  };

  React.useEffect(() => {
    if (eventBusType) {
      evBus.on(eventBusType, onToggle);
    }

    return () => {
      if (eventBusType) {
        evBus.remove(eventBusType, onToggle);
      }
    };
  }, [eventBusType]);

  const contextValue = React.useMemo(() => {
    return {
      open: state.open,
      onToggle: onToggle,
    };
  }, [state, onToggle, eventBusType]);

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>{children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default MyTicketsToggler;
